const NON_ZERO_COMPLETE = [
    'workloadInfo',
    'completeNum'
]

export {
    NON_ZERO_COMPLETE
}